{
  "table": {
    "complianceState": "Compliance state",
    "complianceStateOptions": {
      "ANY": "Any",
      "APPROVED": "Approved",
      "NEEDS_REVIEW": "Needs review",
      "REJECTED": "Rejected"
    },
    "accountType": "Account Type",
    "state": "State",
    "stateOptions": {
      "ANY": "Any",
      "ACTIVE": "Active",
      "AWAITING_APPROVAL": "Awaiting Approval",
      "INACTIVE": "Inactive"
    },
    "iDVerified": "ID Verified",
    "idVerifiedOptions": {
      "ANY": "Any",
      "YES": "Yes",
      "NO": "No"
    },
    "organization": "Organization",
    "client": "Client",
    "account": "Account",
    "age": "Age",
    "annualIncome": "Annual Income",
    "annualDebtPayments": "Annual Debt Payments",
    "totalDebt": "Total Debt",
    "liquidAssets": "Liquid Assets",
    "totalAssets": "Total Assets",
    "netWorth": "Net Worth",
    "debtAssetRatio": "Debt To Asset Ratio",
    "debtServiceRatio": "Debt Service Ratio",
    "employment": "Employment",
    "jobTitle": "Job Title",
    "companyType": "Company Type",
    "entityOfInterest": "Person or Entity of Interest",
    "userSuitablitiy": "User Suitability Score",
    "goalSuitability": "Goal Suitability Score",
    "suggestedPortfolio": "Suggested Portfolio",
    "idVerified": "ID verified",
    "actualPortfolio": "Portfolio",
    "completedAt": "Completed At",
    "subAccountStatus": "Sub-account Status",
    "actions": "Actions",
    "yes": "Yes",
    "no": "No",
    "new": "New",
    "updated": "Updated",
    "isVulnerablePerson": "Vulnerable Person",
    "isOwnerOfEntity": "Owner of Entity"
  },
  "approveAndSign": "Approve and Sign",
  "inherited": "Inherited - "
}
